import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MAINTENANCE_503_REASON } from '@phoenix/common';
import { Observable, tap } from 'rxjs';
import { MaintenanceService } from '../services/maintenance.service';

/**
 * HTTP interceptor that detects 503 responses with reason RESTORE_MAINTENANCE (real DB restore).
 * When detected, shows a full-screen maintenance overlay and starts polling until bootstrap is ready.
 *
 * Bootstrap-only 503s (reason BOOTSTRAPPING) and nginx upstream-unavailable responses do not
 * trigger this overlay.
 */
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
    private maintenanceService = inject(MaintenanceService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap({
                error: (err: any) => {
                    if (err instanceof HttpErrorResponse && err.status === 503) {
                        if (this.isRestoreMaintenanceResponse(err)) {
                            this.maintenanceService.enterMaintenanceMode();
                        }
                    }
                },
            }),
        );
    }

    /**
     * True only when the backend is in restore maintenance (reason RESTORE_MAINTENANCE).
     */
    private isRestoreMaintenanceResponse(response: HttpErrorResponse): boolean {
        const body = response.error;
        if (body && typeof body === 'object') {
            return (body as { reason?: string }).reason === MAINTENANCE_503_REASON.RESTORE_MAINTENANCE;
        }
        if (typeof body === 'string') {
            try {
                const parsed = JSON.parse(body) as { reason?: string };
                return parsed.reason === MAINTENANCE_503_REASON.RESTORE_MAINTENANCE;
            } catch {
                return false;
            }
        }
        return false;
    }
}
